import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Box, Button, FormControl, TextField } from '@mui/material';
import { Link } from 'react-router-dom';

import { OverlayContext } from '../../../../contextProviders/OverlayContext';
import { AccessDataContext } from '../../../../contextProviders/AccessDataContext';
import { useValidation } from '../../../../hooks/UseValidation';
import envirolabLogo from '../../../../resources/images/Envirolab-family-330x150.png';

const ForgotPassword = () => {
  const { setShowLoadingOverlay } = useContext(OverlayContext);
  const { validateEmail } = useValidation();
  const { forgotPassword } = useContext(AccessDataContext);

  const [email, setEmail] = useState('');
  const [emailValid, setEmailValid] = useState(true);
  const [forgotPasswordSuccessful, setForgotPasswordSuccessful] = useState(false);

  const submitForgotPassword = useCallback(
    (e) => {
      e.preventDefault();

      if (!emailValid) {
        return;
      }

      setShowLoadingOverlay(true);

      const data = {
        Email: email,
      };

      forgotPassword(data).then((returnVal) => {
        if (returnVal && returnVal.message && returnVal.message === 'Success') {
          setForgotPasswordSuccessful(true);
        }
        setShowLoadingOverlay(false);
      });
    },
    [email, emailValid, setShowLoadingOverlay, forgotPassword]
  );

  useEffect(() => {
    setEmailValid(validateEmail(email));
  }, [email, validateEmail]);

  return (
    <Box id="loginBox">
      <Box className="imageBox">
        <img alt="Envirolab logo" src={envirolabLogo} />
      </Box>

      <h1>Forgot Password</h1>

      <form onSubmit={submitForgotPassword}>
        <FormControl fullWidth>
          <TextField
            label="Email"
            name="email"
            error={!emailValid}
            helperText={!emailValid ? 'Email address is not valid' : ''}
            onChange={(item) => setEmail(item.target.value)}
            required
          />
        </FormControl>

        <Button className="siteBtn" type="submit" variant="outlined" size="large">
          Submit
        </Button>

        {forgotPasswordSuccessful ? (
          <Box className="successBox">
            Request sent. If email has been registered, please check your inbox. Please click <Link to="/">here</Link> to return to login
          </Box>
        ) : null}
      </form>
    </Box>
  );
};

export default ForgotPassword;
